// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DUmR","title":"styles_title__3zMLl"};